<template>
  <div class="item">
    <div class="titleArea">
      <h2>{{ t("settings-notifications") }}</h2>
    </div>
    <div class="infoArea">
      <ul class="notice flex">
        <li class="flex">
          <div class="leftArea">
            <div class="textArea">
              <h3>{{ t("notifications-agree-title") }}</h3>
              <p>{{ t("notifications-agree-content") }}</p>
            </div>
          </div>
          <div class="rightArea" @click.stop="onClickCheckBox">
            <!-- 스위치 킬 때 switchToggleWrap에 on클래스 주세요 -->
            <div class="switchToggleWrap" :class="{ on : userStore.userV2.isMarketingConsent }">
              <div class="toggleCircle"></div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useUserService} from "~/composables/service/useUserService";
import {useI18n} from "vue-i18n";
import {ToastType} from "~/components/Common/Toast/model/ToastType";
import {useToastStore} from "~/store/toast/toastStore";
import {useUserStore} from "~/store/user/userStore";

const { t } = useI18n()

const toastStore = useToastStore();
const userStore = useUserStore();
const userService = useUserService();

const onClickCheckBox = () => {
  userService.setMarketingTerms(!userStore.userV2.isMarketingConsent)
      .then(isSuccess => {
        if(isSuccess) userStore.userV2.isMarketingConsent = !userStore.userV2.isMarketingConsent
        toastStore.openToast({
          toastType: isSuccess ? ToastType.SUCCESS : ToastType.FAILED,
          contents: isSuccess ? t("notifications-change-success") : t("notifications-change-fail")
        });
      })
}
</script>
